var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doomyogahome"},[_c('SidebarDoomYoga'),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('NavbarDoomYoga'),_vm._v(" "),_c('div',{staticClass:"content",staticStyle:{"margin-top":"50px"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2013798a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/doom_yoga/Home.vue
// module id = null
// module chunks = 